export default "__VITE_ASSET__BP53Cj7a__"